"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumCompanyProfilePage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_breakpoints_1 = require("styled-breakpoints");
const styled_components_1 = __importDefault(require("styled-components"));
const useConfig_1 = require("@src/hooks/useConfig");
const PremiumCompanyProfileFeatures_1 = require("./PremiumCompanyProfileFeatures");
const PremiumCompanyProfileSubscriptionCard_1 = require("./PremiumCompanyProfileSubscriptionCard");
const PremiumCompanyProfileComparisonTable_1 = require("./PremiumCompanyProfileComparisonTable");
const PremiumCompanyProfilePage = () => {
    const [showPricesWithVat, setShowPricesWithVat] = react_1.default.useState(false);
    const config = (0, useConfig_1.useConfig)();
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(Hero, { children: (0, jsx_runtime_1.jsx)(elements_1.Holder, { children: (0, jsx_runtime_1.jsxs)(Headline, { children: [(0, jsx_runtime_1.jsx)("h1", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.headline" }) }), (0, jsx_runtime_1.jsx)("h2", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.sub_headline" }) })] }) }) }), (0, jsx_runtime_1.jsxs)(Content, { children: [(0, jsx_runtime_1.jsx)(elements_1.Holder, { children: (0, jsx_runtime_1.jsxs)(BoxesWrapper, { children: [(0, jsx_runtime_1.jsx)(BoxesTitle, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.subscription_price" }) }), (0, jsx_runtime_1.jsxs)(Boxes, { children: [(0, jsx_runtime_1.jsx)(PremiumCompanyProfileSubscriptionCard_1.PremiumCompanyProfileSubscriptionCard, { subscriptionPeriod: types_1.SubscriptionPeriods.OneMonthPeriod, showPricesWithVat: showPricesWithVat }), (0, jsx_runtime_1.jsx)(PremiumCompanyProfileSubscriptionCard_1.PremiumCompanyProfileSubscriptionCard, { subscriptionPeriod: types_1.SubscriptionPeriods.SixMonthsPeriod, showPricesWithVat: showPricesWithVat, isElevated: true }), (0, jsx_runtime_1.jsx)(PremiumCompanyProfileSubscriptionCard_1.PremiumCompanyProfileSubscriptionCard, { subscriptionPeriod: types_1.SubscriptionPeriods.TwelveMonthsPeriod, showPricesWithVat: showPricesWithVat })] }), (0, jsx_runtime_1.jsxs)(SwitchWrapper, { children: [(0, jsx_runtime_1.jsxs)(SwitchVatText, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.show_prices_with_vat" }), ' ', (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: config.pricing.VAT, style: "unit", unit: "percent" })] }), (0, jsx_runtime_1.jsx)(elements_1.Switch, { checked: showPricesWithVat, onChange: checked => setShowPricesWithVat(checked) })] })] }) }), (0, jsx_runtime_1.jsx)(elements_1.Holder, { children: (0, jsx_runtime_1.jsx)(PremiumCompanyProfileComparisonTable_1.PremiumCompanyProfileComparisonTable, {}) }), (0, jsx_runtime_1.jsx)(FeaturesWrapper, { children: (0, jsx_runtime_1.jsxs)(elements_1.Holder, { children: [(0, jsx_runtime_1.jsx)("h2", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.headline" }) }), (0, jsx_runtime_1.jsx)(PremiumCompanyProfileFeatures_1.PremiumCompanyProfileFeatures, {})] }) })] })] }) }));
};
exports.PremiumCompanyProfilePage = PremiumCompanyProfilePage;
const Wrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	background: ${({ theme }) => theme.color.gray2};
`;
const Headline = styled_components_1.default.div `
	position: relative;
	z-index: 1;
	text-align: center;
	padding: 3.5em 2em 0;

	${(0, styled_breakpoints_1.up)('sm')} {
		padding: 2.5em 2em 0;
	}

	${(0, styled_breakpoints_1.up)('md')} {
		padding: 5em 2em 0;
	}

	& > * {
		color: ${props => props.theme.color.white};
	}
	h1 {
		font-size: 2.4em;
		font-weight: bold;
		margin-bottom: 0.5em;
	}
	h2 {
		font-size: 1.4em;
		font-weight: 200;
		line-height: 1.4;
	}
`;
const Hero = styled_components_1.default.div `
	padding-top: ${props => props.theme.size.headerHeight}px;
	width: 100%;
	height: 800px;
	position: relative;
	background: url('/media/images/hero-premium-profile.jpg');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center 0;

	&:after {
		content: '';
		display: block;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		position: absolute;
		z-index: 0;
		pointer-events: none;
		opacity: 0.95;
		background: url('/media/images/background-gradient.jpg');
		background-repeat: no-repeat;
		background-size: cover;
	}
`;
const Content = styled_components_1.default.div `
	width: 100%;
`;
const SwitchVatText = styled_components_1.default.div `
	font-size: 1rem;
	color: ${({ theme }) => theme.color.white};
	margin-right: 0.5rem;
`;
const SwitchWrapper = styled_components_1.default.div `
	border-radius: 0.5rem;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${({ theme }) => theme.color.lightSlateGray};
	padding: 1rem;
	/* ${(0, styled_breakpoints_1.up)('md')} {
		background: unset;
		padding: 0;
	} */
`;
const Boxes = styled_components_1.default.div `
	position: relative;
	z-index: 1;
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	gap: 1rem;
	${(0, styled_breakpoints_1.up)('md')} {
		flex-direction: row;
	}
`;
const BoxesWrapper = styled_components_1.default.div `
	width: 100%;
	position: relative;
	z-index: 1;
	display: flex;
	margin-top: -420px;
	justify-content: center;
	flex-direction: column;
	gap: 1rem;
	${(0, styled_breakpoints_1.up)('sm')} {
		margin-top: -490px;
	}

	${(0, styled_breakpoints_1.up)('md')} {
		margin-top: -460px;
	}
`;
const BoxesTitle = styled_components_1.default.div `
	font-size: 1.4rem;
	font-weight: 500;
	line-height: 1.4;
	z-index: 1;
	text-align: center;
	color: ${({ theme }) => theme.color.white};
`;
const FeaturesWrapper = styled_components_1.default.div `
	width: 100%;
	padding: 5rem 0 2rem;
	background: ${({ theme }) => theme.color.white};

	h2 {
		color: ${props => props.theme.color.brand4};
		font-size: 2rem;
		text-align: center;
		font-weight: 700;
		margin: 0 0 2rem;
	}
`;
